import { render, staticRenderFns } from "./receiver.vue?vue&type=template&id=2d2d740b&scoped=true&"
import script from "./receiver.vue?vue&type=script&lang=js&"
export * from "./receiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2d740b",
  null
  
)

export default component.exports